import type React from "react";
import { i18nFilter } from "app/filters/i18nFilter";
import { StepClose } from "app/pages/digital-suite/home-page/components/ActivationWizard/Components/StepClose";
import type { ICompletionStep } from "app/pages/digital-suite/home-page/components/ActivationWizard/ActivationWizardUtils";
import {
    StepsCompletionContainer,
    CompletionStepContainer,
    ContentContainer,
    Title,
    Description,
    ButtonsContainer,
    NewSearchButton,
    Image,
    HeaderContentContainer,
} from "app/pages/digital-suite/home-page/components/ActivationWizard/Components/StepsCompletionStyled";

interface IStepsCompletion {
    buttonText: string;
    statusText: string;
    allStepsSkipped: boolean;
    onShowButtonClick: () => void;
    onCtaButtonClick: (callback: () => void) => void;
    completionStepData: ICompletionStep;
}

export const StepsCompletion: React.FC<IStepsCompletion> = ({
    buttonText,
    statusText,
    allStepsSkipped,
    onShowButtonClick,
    onCtaButtonClick,
    completionStepData,
}) => {
    const i18n = i18nFilter();

    return (
        <StepsCompletionContainer>
            <StepClose
                isButtonShowAlways
                title={statusText}
                buttonText={buttonText}
                onClick={onShowButtonClick}
                isSkip={false}
                stepIndex={0}
                isAllSkipped={allStepsSkipped}
            />
            <CompletionStepContainer>
                <ContentContainer>
                    <HeaderContentContainer>
                        <Title>{i18n(completionStepData.title)}</Title>
                        <Description>{i18n(completionStepData.description)}</Description>
                    </HeaderContentContainer>
                    <ButtonsContainer>
                        <NewSearchButton onClick={() => onCtaButtonClick(completionStepData.onClick)}>
                            {i18n(completionStepData.buttonText)}
                        </NewSearchButton>
                    </ButtonsContainer>
                </ContentContainer>
                <Image src={completionStepData.illustration} />
            </CompletionStepContainer>
        </StepsCompletionContainer>
    );
};
